/**
 * De quiz als paneel over de site heen, in plaats van als eigen pagina.
 *
 * Nagebouwd naar wat de keuzehulp van Aiden op hekosolar.com doet, want dat is de plek waar deze
 * quiz straks komt te staan (Guus, 2026-08-30). Hun opzet: body-scroll op slot, een vast paneel
 * over het scherm, en ?aidenModal=<id> in de URL. Dat laatste is het slimste eraan - de terugknop
 * sluit het paneel, en een advertentie kan er rechtstreeks naartoe linken. Hier is dat ?quiz=open.
 *
 * WAAROM GEEN IFRAME, terwijl Aiden er wel een gebruikt. Dat kan niet met een Shopify-pagina.
 * De storefront stuurt op elke pagina mee:
 *
 *   x-frame-options: DENY
 *   content-security-policy: ... frame-ancestors 'none' ...
 *
 * Shopify weigert dus zijn eigen pagina's in een frame, ook binnen dezelfde site. Daarom draait
 * de keuzehulp van Aiden op app.aiden.cx en niet op hekosolar.com - ze hadden geen keus.
 *
 * Wat wél mag is fetch: we halen dezelfde kale pagina op, knippen er het quizblok uit en zetten
 * dat in het paneel. De opmaak komt uit een apart, ingekapseld stijlblad (-scoped.css), waarin
 * elke selector onder #heko-quiz hangt. Zonder dat zouden de body- en h1-regels van de quiz de
 * winkel eronder verbouwen.
 */
(function () {
  var PARAM = "quiz";
  var BRON = "/pages/off-grid-quiz?view=heko-quiz-kaal";

  // Waar geklikt kan worden.
  //
  // Zolang de knoppen van Aiden op de site staan, neemt onze quiz ze over. Zo is de overstap één
  // wijziging in theme.liquid, zonder dat er ook maar één sectie aangepast hoeft te worden - en
  // terugdraaien is dat blok er weer uit halen.
  //
  // Aiden heeft VIJF soorten ingang, en dat is niet te raden; het is uitgezocht in het live thema
  // (2026-08-31). De eerste versie hier ving er maar één van:
  //
  //   .keuzehulp-btn        de header, in een variant voor desktop en een voor mobiel
  //   [data-advisor-id]     losse knoppen in de collectie- en productsjablonen
  //   ?aidenModal=<id>      links vanaf productpagina's en de GemPages-blokken
  //
  // Die derde is geen knop maar een adres, en wordt daarom apart afgevangen - zie `vanAiden`
  // hieronder en de controle bij het laden.
  var KNOPPEN = "[data-heko-quiz], .keuzehulp-btn, [data-advisor-id]";

  /** Wijst dit element naar de keuzehulp van Aiden, via welk attribuut dan ook? */
  function vanAiden(el) {
    while (el && el.attributes) {
      if (el.matches && el.matches(KNOPPEN)) return true;
      for (var i = 0; i < el.attributes.length; i++) {
        if (String(el.attributes[i].value).indexOf("aidenModal") >= 0) return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  /**
   * Het paneel van Aiden weghalen als het toch opengaat.
   *
   * Hun script laadt met `async` en het onze met `defer`, dus wie er eerst is staat niet vast.
   * Komt iemand binnen op een adres met ?aidenModal= erin, dan kan hun paneel er al staan voordat
   * wij het adres hebben opgeschoond. Twee keuzehulpen over elkaar is erger dan de verkeerde.
   */
  function weerAiden() {
    [50, 400, 1200, 3000].forEach(function (na) {
      setTimeout(function () {
        var hun = document.querySelector(".aiden-modal");
        if (hun) hun.remove();
      }, na);
    });
  }

  var paneel = null;
  var geladen = false;

  function bouwPaneel() {
    paneel = document.createElement("div");
    paneel.className = "heko-quiz-modal";
    paneel.setAttribute("role", "dialog");
    paneel.setAttribute("aria-modal", "true");
    paneel.setAttribute("aria-label", "Welk systeem past bij jou?");

    var venster = document.createElement("div");
    venster.className = "heko-quiz-venster";
    venster.appendChild(el("div", "heko-quiz-laadt", "Even geduld…"));
    paneel.appendChild(venster);

    var sluit = document.createElement("button");
    sluit.className = "heko-quiz-sluit";
    sluit.type = "button";
    sluit.setAttribute("aria-label", "Sluiten");
    sluit.innerHTML = "<span>Sluiten</span><svg viewBox='0 0 24 24' aria-hidden='true'>" +
      "<path d='M5 5l14 14M19 5L5 19'/></svg>";
    sluit.addEventListener("click", function () { dicht(true); });
    paneel.appendChild(sluit);

    // Klikken naast het venster sluit ook. Binnen het venster niet, anders sluit elk antwoord
    // de quiz af.
    paneel.addEventListener("click", function (e) {
      if (e.target === paneel) dicht(true);
    });

    document.body.appendChild(paneel);
    return venster;
  }

  function el(tag, klasse, tekst) {
    var d = document.createElement(tag);
    if (klasse) d.className = klasse;
    if (tekst) d.textContent = tekst;
    return d;
  }

  /**
   * De quiz ophalen en in het venster zetten. Eén keer per bezoek.
   *
   * Daarna blijft het paneel in de pagina staan, alleen verborgen. Dat is niet alleen goedkoper -
   * de quizcode is een IIFE en start maar één keer - het is ook wat de klant wil: sluit hij het
   * paneel en opent hij het opnieuw, dan staat hij nog bij dezelfde vraag.
   */
  function laden(venster) {
    if (geladen) return;
    geladen = true;

    fetch(BRON, { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var quiz = doc.getElementById("heko-quiz");
        if (!quiz) throw new Error("geen #heko-quiz in de opgehaalde pagina");

        // De ingekapselde opmaak, één keer. De pagina zelf laadt de niet-ingekapselde versie;
        // die willen we hier juist niet, want die schrijft over het thema heen.
        var stijl = doc.querySelector('link[href*="heko-off-grid-quiz.css"]');
        if (stijl && !document.querySelector('link[data-heko-quiz-css]')) {
          var link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = stijl.getAttribute("href").replace("heko-off-grid-quiz.css", "heko-off-grid-quiz-scoped.css");
          link.setAttribute("data-heko-quiz-css", "");
          document.head.appendChild(link);
        }

        venster.innerHTML = "";
        venster.appendChild(quiz);

        // Het script als laatste: het zoekt de elementen op die we net hebben neergezet.
        var bron = doc.querySelector('script[src*="heko-off-grid-quiz.js"]');
        if (bron) {
          var s = document.createElement("script");
          s.src = bron.getAttribute("src");
          document.body.appendChild(s);
        }
      })
      .catch(function (e) {
        venster.innerHTML = "";
        var p = el("div", "heko-quiz-laadt");
        p.appendChild(el("p", null, "De keuzehulp kon niet geladen worden."));
        var a = document.createElement("a");
        a.href = "/pages/off-grid-quiz";
        a.textContent = "Open hem op een eigen pagina";
        p.appendChild(a);
        venster.appendChild(p);
        if (window.console) console.warn("heko-quiz:", e);
      });
  }

  function open(vanUrl, bron) {
    // Waar de quiz vandaan komt, zodat de meting het weet.
    //
    // Zonder dit is de afhaak op het beginscherm niet te verklaren: je ziet dat een kwart van de
    // bezoekers daar stopt, maar niet of ze zelf op een knop drukten of dat het paneel over hun
    // productpagina heen sprong (Guus, 2026-09-09). De quiz zelf weet niet dat hij in een paneel
    // staat - dat moet zo blijven - dus zet de overlay het hier klaar.
    window.HEKO_QUIZ_CONTEXT = {
      via: "paneel",
      bron: bron || "onbekend",
      pad: location.pathname,
    };
    var venster;
    if (!paneel) venster = bouwPaneel();
    else {
      paneel.classList.remove("heko-quiz-dicht");
      venster = paneel.querySelector(".heko-quiz-venster");
    }
    laden(venster);

    document.body.classList.add("heko-quiz-open");
    document.addEventListener("keydown", opEscape);

    // De URL meeschrijven, zodat de terugknop het paneel sluit. Niet doen als we juist ván die
    // URL komen - dan zou er een tweede stap in de geschiedenis komen en moet de klant twee keer
    // terug om weg te zijn.
    if (!vanUrl) {
      var u = new URL(window.location.href);
      u.searchParams.set(PARAM, "open");
      history.pushState({ hekoQuiz: true }, "", u.toString());
    }
  }

  function dicht(viaGeschiedenis) {
    if (!paneel) return;
    paneel.classList.add("heko-quiz-dicht");
    document.body.classList.remove("heko-quiz-open");
    document.removeEventListener("keydown", opEscape);
    if (viaGeschiedenis && history.state && history.state.hekoQuiz) history.back();
    else if (viaGeschiedenis) {
      var u = new URL(window.location.href);
      u.searchParams.delete(PARAM);
      history.replaceState({}, "", u.toString());
    }
  }

  function opEscape(e) {
    if (e.key === "Escape") dicht(true);
  }

  document.addEventListener("click", function (e) {
    if (!vanAiden(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    weerAiden();
    open(false, "knop");
  }, true);

  window.addEventListener("popstate", function () {
    if (new URL(window.location.href).searchParams.get(PARAM) === "open") open(true, "terugknop");
    else dicht(false);
  });

  // Rechtstreeks binnenkomen op ?quiz=open, bijvoorbeeld vanuit een advertentie. En op
  // ?aidenModal=<id>, want daar linken de productpagina's en de GemPages-blokken naartoe; die
  // adressen staan in metafields en in vormgevingsblokken, en die willen we niet allemaal langs.
  function bijStart() {
    var u = new URL(window.location.href);
    if (u.searchParams.get(PARAM) === "open") { open(true, "link-quiz"); return; }
    if (u.searchParams.has("aidenModal")) {
      // Het adres opschonen zodat hun script er niets meer mee kan, en dan het onze openen.
      u.searchParams.delete("aidenModal");
      history.replaceState({}, "", u.toString());
      weerAiden();
      open(true, "link-aiden");
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bijStart);
  else bijStart();
})();
